function initCardSwatches() {
  document.querySelectorAll('[data-card-swatches]').forEach((swatchContainer) => {
    if (swatchContainer.dataset.swatchesInit) return;
    swatchContainer.dataset.swatchesInit = 'true';

    const card = swatchContainer.closest('.card-wrapper');
    const img = card?.querySelector('.card__media img.motion-reduce');
    if (!img) return;

    const originalSrc = img.src;
    const originalSrcset = img.srcset;

    swatchContainer.querySelectorAll('.card__swatch-btn').forEach((btn) => {
      btn.addEventListener('mouseenter', () => {
        const url = btn.dataset.imageUrl;
        if (url) {
          img.src = url;
          img.srcset = '';
        }
      });

      btn.addEventListener('click', () => {
        const url = btn.dataset.imageUrl;
        if (url) {
          img.src = url;
          img.srcset = '';
          swatchContainer.querySelectorAll('.card__swatch-btn').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
        }
      });
    });

    swatchContainer.addEventListener('mouseleave', () => {
      const activeBtn = swatchContainer.querySelector('.card__swatch-btn.is-active');
      if (!activeBtn) {
        img.src = originalSrc;
        img.srcset = originalSrcset;
      }
    });
  });
}

// Beim Laden + bei dynamisch nachgeladenen Inhalten
document.addEventListener('DOMContentLoaded', initCardSwatches);
document.addEventListener('shopify:section:load', initCardSwatches);

// Fallback: nochmal nach kurzem Delay
setTimeout(initCardSwatches, 500);
